<div class="wa-slider" #slider>
  @if (isOpen) {
    <div class="wa-slider-body">
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Conversion
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          @for (conversion of conversionForm.controls; track conversion; let i = $index) {
            <div [formGroup]="conversion">
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Select Account </label>
                </div>
                <clickatell-form-validation [controlName]="'whatsappBusinessId'"
                [form]="conversion"></clickatell-form-validation>
                <div class="parent">
                  <input type="text"
                    #whatsappBusinessId
                    placeholder="Search or select an Account"
                    matInput
                    [id]="'whatsappBusinessId'"
                    [activeForm]="conversion"
                    class="layer1 control-select control-select-spacer"
                    [formControlName]="'whatsappBusinessId'"
                    [matAutocomplete]="auto"
                    (input)="wabaFilter(whatsappBusinessId)"
                    />
                  </div>
                  <mat-autocomplete
                    autoActiveFirstOption
                    #auto="matAutocomplete"
                    [displayWith]="waBusinessAccountsDisplay.bind(this)">
                    <ng-container>
                      @if (!waBusinessAccounts) {
                        <mat-option disabled class="data-select-option"
                          [ngStyle]="{ 'line-height': 1 }">
                          <loading-icon class="align-loading"></loading-icon>
                        </mat-option>
                      }
                      @if (waBusinessAccounts) {
                        @if (waBusinessAccountsFiltered?.length == 0) {
                          <mat-option disabled
                            class="data-select-option-nonfound resNotFound"
                            [ngStyle]="{ 'line-height': 1 }">
                            No results found.
                          </mat-option>
                        }
                        @if (waBusinessAccountsFiltered?.length > 0  && waBusinessAccountsFiltered[0].id != null) {
                          @for (account of waBusinessAccountsFiltered; track account) {
                            <mat-option
                              [value]="account.wabaId">
                              {{ account.wabaName }}
                            </mat-option>
                          }
                        }
                        @if (waBusinessAccounts[0].id == null) {
                          <mat-option disabled class="data-select-option-nonfound resNotFound"
                            [ngStyle]="{ 'line-height': 1 }">
                            No Accounts available.
                          </mat-option>
                        }
                      }
                    </ng-container>
                  </mat-autocomplete>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Dataset Id </label>
                  </div>
                  <clickatell-form-validation [controlName]="'datasetId'"
                  [form]="conversion"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="conversion" id="datasetId"
                    [formControlName]="'datasetId'" placeholder="Enter Dataset Id">
                  </div>
                  <clickatell-expansion-panel>
                    <ng-container header>
                      <mat-panel-title>
                        Events
                      </mat-panel-title>
                    </ng-container>
                    @if (conversion.controls.events.controls; as events) {
                      <ng-container body>
                        <div class="control-add-button">
                          <div (click)="onAddNewEvent(conversion.controls.events)" class="addText">
                            <span class="control-label-add-btn-icon">
                              <img class="action-img" src='./assets/svg/addIcon.svg'/>
                            </span>
                            <span class="control-label-add-btn-label">Add new event</span>
                          </div>
                        </div>
                        @for (option of events; track option; let eventIndex = $index) {
                          <mat-expansion-panel
                            [expanded]="true" class="events">
                            <mat-expansion-panel-header class="logic-result-header">
                              <div class="title">
                                @if (eventName.value.length > 0) {
                                  {{ eventName.value }}
                                } @else {
                                  <span class="control-result-defaultTitle">
                                    [Event Name]
                                  </span>
                                }
                              </div>
                              <div class="logic-result-header-btn">
                                <button class="control-result-delete" [disabled]="!isDisabled"
                                  (click)="onDeleteEvent(eventIndex, conversion.controls.events)">
                                  <img class="control-result-delete-btn"
                                    src="./assets/svg/redesign/trash.svg">
                                  </button>
                                </div>
                              </mat-expansion-panel-header>
                              <div class="body">
                                <div class="logic-result-container" [formGroup]="option">
                                  <div class="control-div">
                                    <div class="control-label-container">
                                      <label class="control-label"> Event Name </label>
                                      <label class="control-optional">Required</label>
                                    </div>
                                    <clickatell-form-validation [controlName]="'eventName'"
                                    [form]="option"></clickatell-form-validation>
                                    <input #eventName class="control-input" activeForm [activeForm]="option"
                                      [id]="'eventName-' + eventIndex + 1"
                                      [formControlName]="'eventName'" [attr.name]="'eventName'"
                                      placeholder="Add Event Name"/>
                                    </div>
                                    <div class="control-div">
                                      <div class="control-label-container">
                                        <label class="control-label"> Custom Data </label>
                                        <div class="control-optional">
                                          <div (click)="onAddCustomData(option.controls.customData)"
                                            class="addText">
                                            <span class="control-label-add-btn-icon">
                                              <img class="action-img" src='./assets/svg/addIcon.svg'/>
                                            </span>
                                            <span class="control-label-add-btn-label">Add custom data</span>
                                          </div>
                                        </div>
                                      </div>
                                      @if (option.controls.customData.controls; as customDataControls) {
                                        @for (customDataOption of customDataControls; track customDataOption; let index = $index) {
                                          <div class="control-container" [formGroup]="customDataOption">
                                            <span class="control-container-header">
                                              <label class="label">
                                                {{ customDataControls[index].controls.key.value !== '' ? customDataControls[index].controls.key.value : '[Name]' }}
                                              </label>
                                              <img class="deleteBtn"
                                                src="../../../../../../../../assets/svg/delete-bin.svg"
                                                alt="delete variable"
                                                (click)="onDeleteCustomData(index, option.controls.customData)">
                                              </span>
                                              <clickatell-form-validation [controlName]="'key'"
                                              [form]="customDataOption"></clickatell-form-validation>
                                              <input class="control-input control-container-variable"
                                                [formControlName]="'key'"
                                                placeholder="Custom data Name"/>
                                                <clickatell-form-validation [controlName]="'value'"
                                                [form]="customDataOption"></clickatell-form-validation>
                                                <input class="control-input control-container-variable"
                                                  [formControlName]="'value'"
                                                  placeholder="Custom data Value"/>
                                                </div>
                                              }
                                              @if (customDataControls.length > CUSTOM_DATA_LIMITS.overflow) {
                                                <div class="control-add-button"
                                                  >
                                                  <button [disabled]="!isDisabled"
                                                    (click)="onAddCustomData(option.controls.customData)">
                                                    Add custom data
                                                  </button>
                                                </div>
                                              }
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </mat-expansion-panel>
                                  }
                                  @if (events.length > EVENT_LIMITS.overflow) {
                                    <div class="control-add-button">
                                      <button [disabled]="!isDisabled"
                                        (click)="onAddNewEvent(conversion.controls.events)">
                                        Add new event
                                      </button>
                                    </div>
                                  }
                                </ng-container>
                              }
                            </clickatell-expansion-panel>
                          </div>
                        }
                      </ng-container>
                    </clickatell-expansion-panel>
                  </div>
                }
                @if (isOpen) {
                  <div class="nodeFooterHolder">
                    <div class="nodeHeader-button">
                      @if (isDisabled) {
                        <button class="btn clear" (click)="onReset()">
                          Clear
                        </button>
                      }
                      <div class="btn close-btn" [ngClass]="{'right-margin': isDisabled}" id="closeTrackNode"
                        (click)="closeOverlay()">Close
                      </div>
                      @if (isDisabled) {
                        <div class="btn save-btn" id="saveTrackNode" (click)="saveSettings()">Save</div>
                      }
                    </div>
                  </div>
                }
              </div>


              <ng-template #confirmationDialog>
                <div class="flow_save_new">
                  <div class="flow_save_new_title">Are you sure you want to clear the conversions?</div>
                  <div class="flow_save_new_buttonsContainer">
                    <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="onResetCancel()">
                      Cancel
                    </button>
                    <button class="toolbar_saveBtn btnPrimary flow_save_new_button"
                      (click)="onConfirmReset()">
                      Clear
                    </button>
                  </div>
                </div>
              </ng-template>